/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMoodIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-mood"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M15.7 11.2Q16.43 11.2 16.94 10.69Q17.45 10.18 17.45 9.45Q17.45 8.72 16.94 8.21Q16.43 7.7 15.7 7.7Q14.97 7.7 14.46 8.21Q13.95 8.72 13.95 9.45Q13.95 10.18 14.46 10.69Q14.97 11.2 15.7 11.2ZM8.3 11.2Q9.03 11.2 9.54 10.69Q10.05 10.18 10.05 9.45Q10.05 8.72 9.54 8.21Q9.03 7.7 8.3 7.7Q7.58 7.7 7.06 8.21Q6.55 8.72 6.55 9.45Q6.55 10.18 7.06 10.69Q7.58 11.2 8.3 11.2ZM12 22.8Q12 22.8 10.88 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.79Q2.9 5.83 4.36 4.36Q5.83 2.9 7.79 2.05Q9.75 1.2 12 1.2Q14.25 1.2 16.21 2.05Q18.18 2.9 19.64 4.36Q21.1 5.83 21.95 7.79Q22.8 9.75 22.8 12Q22.8 14.25 21.95 16.21Q21.1 18.18 19.64 19.64Q18.18 21.1 16.21 21.95Q14.25 22.8 12 22.8ZM12 18Q13.63 18 14.97 17.2Q16.32 16.4 17.13 15.05Q17.3 14.7 17.1 14.38Q16.9 14.05 16.5 14.05L7.5 14.05Q7.1 14.05 6.9 14.38Q6.7 14.7 6.88 15.05Q7.67 16.4 9.03 17.2Q10.38 18 12 18Z" fill={color} />
    </svg>
  );
}
